export const isVideo = (contentType = '') => {
  const videoContentTest = /^video\//
  return videoContentTest.test(contentType)
}

export default isVideo
